import type { Path } from '@lingoda/router';
import {
    TabValue,
    studentClassesPath,
    studentCourseOverviewPath,
    studentHomePath,
    studentPracticePath,
} from '@lingoda/router';
import { ExerciseStatus } from '@lingoda/api';

interface TabProps {
    to: Path;
    track: string;
}

type TopAndBottomTabProps = {
    [K in
        | TabValue.Home
        | TabValue.MyClasses
        | TabValue.CourseOverview
        | TabValue.Practice]: TabProps;
};

export const topAndBottomTabsProps: TopAndBottomTabProps = {
    [TabValue.Home]: {
        to: studentHomePath(),
        track: 'Today',
    },
    [TabValue.MyClasses]: {
        to: studentClassesPath(),
        track: 'My classes',
    },
    [TabValue.CourseOverview]: {
        to: studentCourseOverviewPath(),
        track: 'My course',
    },
    [TabValue.Practice]: {
        to: studentPracticePath({ status: ExerciseStatus.PENDING }),
        track: 'Practice',
    },
};
